export default function Axion() {
  return <div className="img-wrapper axion"></div>;
}
